import React from 'react';
import PropTypes from 'prop-types';
import { join } from 'lodash';
import { Field } from 'formik';
import {
  AddressForm,
  getAddressValidation,
  ContactInfoForm,
  getContactInfoValidation,
  GridContainer,
  GridItem,
  NameForm,
  getNameValidation,
  TextFieldWrapper,
} from '../../common';
import RelationshipField, {
  getRelationshipValidation,
} from './RelationshipField';
const NOTES = 'notes';

function CaregiverForm({ paths, setFieldValue, values }) {
  return (
    <GridContainer>
      <NameForm firstNameRequired lastNameRequired paths={paths} />
      <AddressForm paths={paths} required={false} />
      <ContactInfoForm
        emailRequired={false}
        paths={paths}
        phoneRequired
        setFieldValue={setFieldValue}
        values={values}
      />
      <RelationshipField paths={paths} />
      <GridItem lg={12} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={NOTES}
          label="Notes"
          multiline
          name={join([...paths, NOTES], '.')}
          paths={[...paths, NOTES]}
        />
      </GridItem>
    </GridContainer>
  );
}

CaregiverForm.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  paths: PropTypes.array,
};

CaregiverForm.defaultProps = {
  paths: [],
};

export default CaregiverForm;

export const caregiverValidationSchema = {
  ...getAddressValidation({ required: false }),
  ...getContactInfoValidation({ emailRequired: false, phoneRequired: true }),
  ...getNameValidation({ firstNameRequired: true, lastNameRequired: true }),
  ...getRelationshipValidation({ required: false }),
};



// WEBPACK FOOTER //
// ./src/modules/PrimaryCaregiverPage/components/CaregiverForm.js